<template>
  <div>
    <CommonHeader :page="'Liste des clients'" />

    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <ClientTable title="Table des clients"></ClientTable>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ClientTable from "./Tables/ClientTable";
import CommonHeader from "@/components/CommonHeader";

export default {
  name: "tables",
  components: {
    ClientTable,
    CommonHeader
  }
};
</script>
<style></style>
